<template>
	<div class="case-mask">
		<div class="case-close" @click="$emit('close')">&times;</div>
		<div class="case-scroll">

			<!-- Hero -->
			<header class="hero">
				<span class="hero-tag">火锅产业大脑 · INDUSTRY BRAIN</span>
				<h1>火锅产业数字化转型案例集</h1>
				<p>多个火锅产业主体依托火锅产业大脑，实现种养到配套服务全环节数字化转型；平台依托业务中台，汇聚产业图谱、数据库、人才服务，融合集采、零售与供应链金融，以数据赋能全产业链提效。</p>
				<div class="hero-stats">
					<div class="hero-stat" v-for="stat in heroStats" :key="stat.label">
						<div class="num">{{ stat.num }}</div>
						<div class="label">{{ stat.label }}</div>
					</div>
				</div>
			</header>

			<!-- 案例列表 -->
			<main class="cases">
				<section class="case" v-for="item in cases" :key="item.num">
					<div class="case-img">
						<img :src="item.img" :alt="item.alt" />
					</div>
					<div class="case-info">
						<span class="case-num">{{ item.num }}</span>
						<h2>{{ item.title }}</h2>
						<p class="pain">{{ item.pain }}</p>
						<p class="solution">{{ item.solution }}</p>
						<div class="case-metrics">
							<div class="metric" v-for="(m, i) in item.metrics" :key="i">
								<div class="v">{{ m.v }}</div>
								<div class="k">{{ m.k }}</div>
							</div>
						</div>
					</div>
				</section>
			</main>

			<footer class="footer">
				火锅产业大脑 · 数据价值化应用案例 &nbsp;|&nbsp; 数据为试点区域测算值，仅供参考
			</footer>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'szhzxCase',
		data() {
			return {
				heroStats: [
					{ num: '4', label: '大典型应用方向' },
					{ num: '30%+', label: '综合成本下降' },
					{ num: '500+', label: '接入转型主体' },
					{ num: '1.2亿', label: '日均处理数据量' }
				],
				cases: [
					{
						num: 'CASE 01',
						title: '智慧供应链 · 集采交易与溯源数字化转型',
						img: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A1%88%E4%BE%8B/case1.png',
						alt: '集采交易与溯源数字化转型',
						pain: '痛点：火锅生鲜食材溯源难、中小商家采购议价弱，上下游账期压力大、供需撮合效率低。',
						solution: '依托产业大脑搭建一物一码溯源体系，打通上游基地与冷链数据。平台搭建 B2B 集采市场，配套供应链金融，线上完成交易对账并缓解资金压力。',
						metrics: [
							{ v: '-28%', k: '食材综合采购成本' },
							{ v: '100%', k: '食材溯源覆盖率' },
							{ v: '+35%', k: '供需履约效率' }
						]
					},
					{
						num: 'CASE 02',
						title: '地方产业主管部门 · 火锅产业治理数字化转型',
						img: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A1%88%E4%BE%8B/case2.png',
						alt: '火锅产业治理数字化转型',
						pain: '痛点：火锅产业底数摸排更新慢、产业链关系不清，各类产业数据分散，缺少数字化监测研判抓手。',
						solution: '产业大脑提供产业一张图、产业链图谱、行业数据库，可视化展示产业主体分布与经营情况。助力识别产业链短板，支撑产业监测、风险预警、招商与行业监管。',
						metrics: [
							{ v: '+55%', k: '产业态势研判效率' },
							{ v: '-40%', k: '线下调研摸排成本' },
							{ v: '100%', k: '产业链主体地图覆盖' }
						]
					},
					{
						num: 'CASE 03',
						title: '火锅行业协会与餐饮经营企业 · 产业人才体系数字化转型',
						img: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A1%88%E4%BE%8B/case3.png',
						alt: '产业人才体系数字化转型',
						pain: '痛点：火锅特色技能人才缺口大，培训认证、求职维权、赛事评优渠道分散，行业人才生态不完善。',
						solution: '产业大脑人才板块集成线上培训、认证核验、求职对接功能。同时开通维权通道，统一发布行业赛事，持续输出持证技能人才、统一行业人才标准。',
						metrics: [
							{ v: '+42%', k: '企业技能人才匹配效率' },
							{ v: '-30%', k: '企业招聘成本' },
							{ v: '3.6倍', k: '持证人才增量' }
						]
					},
					{
						num: 'CASE 04',
						title: '火锅全产业集群 · 依托业务中台实现跨主体全域协同',
						img: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A1%88%E4%BE%8B/case4.png',
						alt: '业务中台跨主体全域协同',
						pain: '痛点：产业链各主体系统孤立形成数据孤岛，各类数字化应用重复建设，多场景能力不通，一二三产融合落地难。',
						solution: '以火锅业务中台作为统一底座，沉淀订单、溯源、人才等公共基础能力。向上支撑产业监测，向下承载各类业务，打通多方链路，快速孵化数字化应用，促进三产融合。',
						metrics: [
							{ v: '+45%', k: '数字化组件复用率' },
							{ v: '-20%', k: '数字化改造成本' },
							{ v: '18+', k: '中台开放能力' }
						]
					}
				]
			}
		}
	}
</script>

<style scoped lang="scss">
	/* 数字化转型案例集：全屏弹出页 */
	.case-mask {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: #0d1117;
		z-index: 10000;
	}

	.case-close {
		position: fixed;
		top: 16px;
		right: 28px;
		z-index: 10001;
		font-size: 40px;
		line-height: 1;
		color: #9ca3af;
		cursor: pointer;
		transition: color .2s;
	}

	.case-close:hover {
		color: #fff;
	}

	.case-scroll {
		height: 100%;
		overflow-y: auto;
		color: #e5e7eb;
		line-height: 1.7;
		font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
	}

	/* ===== Hero ===== */
	.hero {
		position: relative;
		padding: 80px 24px 60px;
		text-align: center;
		background:
			radial-gradient(ellipse at 20% 0%, rgba(232, 93, 47, 0.18), transparent 55%),
			radial-gradient(ellipse at 80% 100%, rgba(59, 130, 246, 0.15), transparent 55%),
			#0d1117;
		border-bottom: 1px solid rgba(255, 255, 255, 0.06);
	}

	.hero-tag {
		display: inline-block;
		padding: 6px 16px;
		border: 1px solid rgba(232, 93, 47, 0.5);
		border-radius: 999px;
		color: #ff8a5c;
		font-size: 13px;
		letter-spacing: 2px;
		margin-bottom: 24px;
	}

	.hero h1 {
		font-size: clamp(30px, 5vw, 52px);
		font-weight: 900;
		letter-spacing: 2px;
		margin-bottom: 18px;
		background: linear-gradient(135deg, #fff 30%, #ff8a5c 100%);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.hero p {
		max-width: 640px;
		margin: 0 auto;
		color: #9ca3af;
		font-size: 16px;
	}

	.hero-stats {
		display: flex;
		justify-content: center;
		gap: 48px;
		margin-top: 44px;
		flex-wrap: wrap;
	}

	.hero-stat .num {
		font-size: 32px;
		font-weight: 900;
		color: #ff6b35;
	}

	.hero-stat .label {
		font-size: 13px;
		color: #6b7280;
		margin-top: 4px;
	}

	/* ===== 案例容器 ===== */
	.cases {
		max-width: 1200px;
		margin: 0 auto;
		padding: 60px 24px;
	}

	.case {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 48px;
		align-items: center;
		padding: 48px 0;
		border-bottom: 1px solid rgba(255, 255, 255, 0.06);
	}

	.case:last-child {
		border-bottom: none;
	}

	.case:nth-child(even) .case-img {
		order: 2;
	}

	.case-img {
		position: relative;
		border-radius: 12px;
		overflow: hidden;
		aspect-ratio: 16/10;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
	}

	.case-img img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.case-img::after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: linear-gradient(180deg, transparent 60%, rgba(13, 17, 23, 0.6));
		pointer-events: none;
	}

	.case-num {
		display: inline-block;
		font-size: 14px;
		font-weight: 700;
		color: #ff6b35;
		letter-spacing: 3px;
		margin-bottom: 12px;
	}

	.case h2 {
		font-size: clamp(22px, 3vw, 30px);
		font-weight: 700;
		margin-bottom: 16px;
		color: #fff;
	}

	.case .pain {
		color: #9ca3af;
		font-size: 14px;
		margin-bottom: 14px;
		padding-left: 12px;
		border-left: 3px solid #e85d2f;
	}

	.case .solution {
		color: #d1d5db;
		font-size: 15px;
		margin-bottom: 20px;
	}

	.case-metrics {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 12px;
	}

	.metric {
		background: rgba(255, 255, 255, 0.03);
		border: 1px solid rgba(255, 255, 255, 0.08);
		border-radius: 8px;
		padding: 14px 12px;
		text-align: center;
	}

	.metric .v {
		font-size: 22px;
		font-weight: 900;
		color: #ff8a5c;
	}

	.metric .k {
		font-size: 12px;
		color: #6b7280;
		margin-top: 4px;
	}

	/* ===== 底部 ===== */
	.footer {
		text-align: center;
		padding: 48px 24px;
		background: #0a0d12;
		color: #6b7280;
		font-size: 13px;
		border-top: 1px solid rgba(255, 255, 255, 0.06);
	}

	@media (max-width: 768px) {
		.hero { padding: 56px 20px 40px; }
		.hero-stats { gap: 28px; }
		.case {
			grid-template-columns: 1fr;
			gap: 24px;
			padding: 36px 0;
		}
		.case:nth-child(even) .case-img { order: 0; }
		.case-metrics { grid-template-columns: repeat(3, 1fr); gap: 8px; }
		.metric .v { font-size: 18px; }
	}
</style>
